{
	"name": "@ainetwork/adk",
	"version": "0.8.9",
	"packageManager": "pnpm@10.33.0",
	"description": "AI Network Agent Development Kit",
	"repository": "git@github.com:ainetwork-ai/ain-adk.git",
	"author": "AI Network (https://ainetwork.ai)",
	"type": "module",
	"engines": {
		"node": ">=20"
	},
	"main": "./dist/cjs/index.cjs",
	"module": "./dist/esm/index.js",
	"types": "./dist/esm/index.d.ts",
	"exports": {
		".": {
			"types": "./dist/esm/index.d.ts",
			"import": "./dist/esm/index.js",
			"require": "./dist/cjs/index.cjs",
			"default": "./dist/esm/index.js"
		},
		"./modules": {
			"types": "./dist/esm/modules/index.d.ts",
			"import": "./dist/esm/modules/index.js",
			"require": "./dist/cjs/modules/index.cjs",
			"default": "./dist/esm/modules/index.js"
		},
		"./types/*": {
			"types": "./dist/esm/types/*.d.ts",
			"import": "./dist/esm/types/*.js",
			"require": "./dist/cjs/types/*.cjs",
			"default": "./dist/esm/types/*.js"
		},
		"./utils/*": {
			"types": "./dist/esm/utils/*.d.ts",
			"import": "./dist/esm/utils/*.js",
			"require": "./dist/cjs/utils/*.cjs",
			"default": "./dist/esm/utils/*.js"
		}
	},
	"files": [
		"dist"
	],
	"scripts": {
		"prebuild": "pnpm clean",
		"build": "tsup",
		"clean": "rm -rf dist",
		"biome": "npx @biomejs/biome check",
		"biome:write": "npx @biomejs/biome check --write",
		"test": "jest --passWithNoTests",
		"prepare": "husky",
		"release": "release-it"
	},
	"keywords": [],
	"license": "MIT",
	"devDependencies": {
		"@biomejs/biome": "2.0.4",
		"@eslint/js": "^9.29.0",
		"@types/cors": "^2.8.19",
		"@types/express": "^5.0.3",
		"@types/jest": "^30.0.0",
		"@types/node": "^24.0.1",
		"@types/supertest": "^7.2.0",
		"eslint": "^9.29.0",
		"husky": "^9.1.7",
		"jest": "^30.0.0",
		"release-it": "^19.0.4",
		"supertest": "^7.2.2",
		"ts-jest": "^29.4.0",
		"ts-node": "^10.9.2",
		"tsup": "^8.5.0",
		"tsx": "^4.20.3",
		"typescript": "^5.8.3",
		"typescript-eslint": "^8.34.1"
	},
	"dependencies": {
		"@a2a-js/sdk": "^0.3.7",
		"@modelcontextprotocol/sdk": "^1.25.1",
		"cors": "^2.8.5",
		"dotenv": "^16.5.0",
		"express": "^5.1.0",
		"helmet": "^8.1.0",
		"http-status-codes": "^2.3.0",
		"node-cron": "^4.2.1",
		"uuid": "^11.1.0",
		"winston": "^3.17.0",
		"winston-daily-rotate-file": "^5.0.0"
	},
	"publishConfig": {
		"registry": "https://registry.npmjs.org"
	}
}
